import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';

class AggregatorUserDataRepository {

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchContacts(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/contacts`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchAccounts(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/companies`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchInteractions(criteria) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/aggregator-user-data/enriched-interactions`,
      {
        params: criteria,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchTasks(criteria) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/aggregator-user-data/enriched-tasks`,
      {
        params: criteria,
      }
    );

    return result.data;
  }
}

const aggregator_user_data_repository = new AggregatorUserDataRepository();

export {
  aggregator_user_data_repository,
};
